var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Change(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8 3 C 6.895 3 6 3.895 6 5 L 6 12 C 6 13.105 6.895 14 8 14 L 11 14 L 11 17 C 11 18.093063 11.906937 19 13 19 L 20 19 C 21.093063 19 22 18.093063 22 17 L 22 10 C 22 8.9069372 21.093063 8 20 8 L 17 8 L 17 5 C 17 3.895 16.105 3 15 3 L 8 3 z M 17 10 L 20 10 L 20 17 L 13 17 L 13 14 L 15 14 C 16.105 14 17 13.105 17 12 L 17 10 z M 2 14 L 2 18 C 2 19.093063 2.9069372 20 4 20 L 7 20 L 7 22 L 10 19 L 7 16 L 7 18 L 4 18 L 4 14 L 2 14 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Change);
export default __webpack_public_path__ + "static/media/icons8-change.99d08294.svg";
export { ForwardRef as ReactComponent };